import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import { SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";
import { schemaDefinePilote } from "../../../features/forms/schemas/schemaDefinePilote";
import { Thematique } from "../../../types/thematiques";
import { UserForList } from "../../../types/user";
import { isDev } from "../../../utils/dev";
import FieldDate from "../fields/FieldDate";
import FieldSelect from "../fields/FieldSelect";

export const formName = "form-event-define-pilote";

export type FormDefinePiloteSchema = z.infer<typeof schemaDefinePilote>;

const gravities = [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
];

type Props = {
  onSubmit: SubmitHandler<FormDefinePiloteSchema>;
  defaultValues?: FormDefinePiloteSchema;
  pilotes: UserForList[];
  admins: UserForList[];
  themes: Thematique[];
};

const FormDefinePilote: React.FC<Props> = ({ onSubmit, pilotes, admins, themes }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormDefinePiloteSchema>({
    defaultValues: {},
    resolver: zodResolver(schemaDefinePilote),
  });

  if (isDev) {
    const formValues = watch(); // Get the form values state
    console.log("formValues", formValues);
    console.log("errors", errors);
  }

  return (
    <Form
      id={formName}
      onFinish={handleSubmit(onSubmit)}
      labelCol={{ span: 4 }}
    >
      <FieldSelect<FormDefinePiloteSchema>
        errorMessage={errors?.pilote?.message}
        control={control}
        name="pilote"
        label="Pilote"
        placeholder="Attribuer Ã "
        options={
          pilotes?.concat(admins).map((user) => ({
            label: user.fullname,
            value: String(user.id),
          })) || []
        }
        isVertical
      />
      <FieldSelect<FormDefinePiloteSchema>
        errorMessage={errors?.gravity?.message}
        control={control}
        name="gravity"
        label="GravitÃ©"
        placeholder="SÃ©lectionner une gravitÃ©"
        options={
          gravities?.map((gravity) => ({
            label: gravity.label,
            value: gravity.value,
          })) || []
        }
        isVertical
      />
      <FieldSelect<FormDefinePiloteSchema>
        errorMessage={errors?.theme?.message}
        control={control}
        name="theme"
        label="ThÃ©matique"
        placeholder="SÃ©lectionner une thÃ©matique"
        options={
          themes?.map((theme) => ({
            label: `${theme.code} - ${theme.description}`,
            value: String(theme.id),
          })) || []
        }
        isVertical
      />
      <FieldDate<FormDefinePiloteSchema>
        errorMessage={errors?.dateAsked?.message}
        control={control}
        name="dateAsked"
        label="Date souhaitÃ©e"
        isVertical
      />
    </Form>
  );
};

export default FormDefinePilote;
